// Imports
import { useStateValue } from '../../_global/jsx/store';
import { ReactFooterNav } from '../../ReactFooterNav/jsx/component.jsx'
import { ReactQuestionThreeAnswers } from '../../ReactQuestionThreeAnswers/jsx/component.jsx';
import { ReactQuestionFourAnswers } from '../../ReactQuestionFourAnswers/jsx/component.jsx';
import { ReactReport } from '../../ReactReport/jsx/component.jsx';
import { ReactHome } from '../../ReactHome/jsx/component.jsx';
import { ReactQuestionCounter } from '../../ReactQuestionCounter/jsx/component.jsx';
import { ReactDetailedOverview } from '../../ReactDetailedOverview/jsx/component.jsx';
import { ReactDetailedAssessmentHub } from '../../ReactDetailedAssessmentHub/jsx/component.jsx';
import { ReactDetailedQuestionSection } from '../../ReactDetailedQuestionSection/jsx/component.jsx';
import { ReactRapidQuestionSection } from '../../ReactRapidQuestionSection/jsx/component.jsx';
import { dangerousHTML } from 'src/lib/utils.js';

// Generic Page used by all Pages. Contains Header, Content and Footer Nav. Determines what additional content to show based on pageType 

export const ReactPage = () => {

    const [{ controlData }, dispatch] = useStateValue();

   

    // Returns additional content if the page is not pageType of  'content'
    const returnAddionalPageContent = () => {
        var pageToReturn;
        if (controlData.currentItem.pageType === 'questionSection') {
            if (controlData.currentItem.assessmentType === 'detailed') {
                pageToReturn = <ReactDetailedQuestionSection />;
            }
            if (controlData.currentItem.assessmentType === 'rapid' || controlData.currentItem.assessmentType === null) {
                pageToReturn = <ReactRapidQuestionSection />;
            }

        } else if (controlData.currentItem.pageType === "report") {
            pageToReturn = <ReactReport />

        } else if (controlData.currentItem.pageType === "detailedOverview") {
            pageToReturn = <ReactDetailedOverview />
        } else if (controlData.currentItem.pageType === "homePage") {
            pageToReturn = <ReactHome />
        } else if (controlData.currentItem.pageType === 'assessment') {
            if (controlData.currentItem.assessmentType === 'detailed') {
                pageToReturn = <ReactDetailedAssessmentHub />
            }
        }
        
        return pageToReturn;
    }

    // If the Page is a question, return the counter
    //const returnQuestionCounter = () => {
    //    if (controlData.currentItem.pageType === 'question') {
    //        return <ReactQuestionCounter />;
    //    }
    //}

    // Return the classes for the main content, additional class if the Page is a question
    const returnContentClasses = () => {
        let classes = 'br-app-main-content';
        if (controlData.currentItem.pageType === 'question') {
            classes += ' br-app-main-content__has-questions';
        }
        return classes;
    }


    React.useEffect( () => {

        dispatch({
            type: 'pageIndexChangeRendered'
        })
        /*
        var firstBtn = document.querySelector('.br-app-main-content__input-group .br-app-btn:first-child');
        if(typeof firstBtn !== 'undefined' && firstBtn !== null) {
            document.querySelector('.br-app-btn').focus()
        }
        console.log('here');*/
    },[controlData.currentIndex]);   


    return (
        <div className="br-app-main-content__wrapper">
            <div className={returnContentClasses()}>
                <div className="br-app-main-content__header">
                    <h2 className="br-app-main-content__header__title">
                        {controlData.currentItem.headerText}
                    </h2>
                </div>

                <div className="br-app-main-content__contents">
                    <div className="br-app-main-content__support" dangerouslySetInnerHTML={dangerousHTML(controlData.currentItem.content)}></div>
                    {
                        returnAddionalPageContent()
                    }
                </div>

                {(controlData.currentItem.pageType !== 'assessment' || controlData.currentItem.assessmentType !== 'detailed') && (
                    <ReactFooterNav > </ReactFooterNav>
                )}

                {controlData.currentItem.pageFooter && (
                    <div className="br-app-main-content__footer" dangerouslySetInnerHTML={dangerousHTML(controlData.currentItem.pageFooter)}></div>
                )}

            </div>
        </div>
    );
};
